import javascript from "../assets/certificates/javascript.jpg";
import jenkins from "../assets/certificates/jenkins.jpg";
import kafka_springboot from "../assets/certificates/kafka_springboot.jpg";
import mern from "../assets/certificates/mern.jpg";
import python from "../assets/certificates/python.jpg";
import rag from "../assets/certificates/rag.jpg";
import sdc from "../assets/certificates/sdc.jpg";

// Certificates reframed as LeetCode "badges".
export const certificates = [
  {
    slug: "rag",
    title: "Retrieval-Augmented Generation (RAG)",
    issuer: "Udemy",
    skills: ["RAG", "Vector Databases", "LangChain"],
    image: rag,
    url: "https://www.udemy.com/certificate/UC-d8a3bf8f-5fd3-4e41-9f16-ff62fa31bb57",
  },
  {
    slug: "jenkins",
    title: "Jenkins",
    issuer: "Udemy",
    skills: ["Jenkins", "CI/CD"],
    image: jenkins,
    url: "https://www.udemy.com/certificate/UC-23d7659c-3772-4d65-994f-97aa8f894741/",
  },
  {
    slug: "kafka-springboot",
    title: "Apache Kafka with SpringBoot",
    issuer: "Udemy",
    skills: ["Kafka", "SpringBoot", "Microservices"],
    image: kafka_springboot,
    url: "https://udemy.com/certificate/UC-ae468373-4b0a-4963-87bb-e3445389655d",
  },
  {
    slug: "mern",
    title: "MERN Stack: Fullstack with Redux",
    issuer: "Udemy",
    skills: ["MongoDB", "ExpressJS", "ReactJS", "NodeJS", "ReduxJS"],
    image: mern,
    url: "https://www.udemy.com/certificate/UC-c7700e77-718e-453b-81fe-440d0bfed8fc/",
  },
  {
    slug: "python",
    title: "Python",
    issuer: "Coursera",
    skills: ["Python Programming", "Scripting"],
    image: python,
    url: "https://www.coursera.org/account/accomplishments/certificate/ZL34YXNN96EW",
  },
  {
    slug: "nodejs",
    title: "Server-side JavaScript with Node.js",
    issuer: "Coursera",
    skills: ["JavaScript", "Node.js", "File Systems", "Mocha", "Chai"],
    image: javascript,
    url: "https://www.coursera.org/account/accomplishments/certificate/K3PP47M246HD",
  },
  {
    slug: "self-driving-cars",
    title: "Self Driving Cars",
    issuer: "Coursera",
    skills: [
      "Computer Vision",
      "Simulations",
      "Embedded Software",
      "Vehicle Modelling & Control",
    ],
    image: sdc,
    url: "https://www.coursera.org/account/accomplishments/certificate/VRJV99MEAM6K",
  },
];

export default certificates;
